// organize-imports-ignore
import "src/globalThis";
import { ApolloProvider } from "@apollo/client/react";
import { RouterProvider } from "react-router-dom";
import { router } from "src/routing/Router";
import { amplifyConfig, createApolloClient, getStage } from "./context";
import { enableAnalytics } from "./utils/analytics";
import { configure } from "mobx";
import { hideIdColumn, showIdColumn } from "src/utils/idColumn";
import "src/utils/fetchMonkeyPatch";
import { createRoot } from "react-dom/client";
import { configureAuth } from "@homebound/auth-components";
import "@homebound/beam/index.css";
import "virtual:truss.css";
import { setupEnvironmentFavicon } from "./environmentFavicon";

const stage = getStage();
const apolloClient = createApolloClient(stage);
configureAuth(amplifyConfig(stage));
void enableAnalytics(stage);
configure({ enforceActions: "never" });
// Amplify.Logger.LOG_LEVEL = "DEBUG";

// Allow developers to easily turn on the conditional id columns for debugging
Object.assign(global, { showIdColumn, hideIdColumn });

const container = document.getElementById("root");
const root = createRoot(container!);

setupEnvironmentFavicon();

root.render(
  <ApolloProvider client={apolloClient}>
    <RouterProvider router={router} />
  </ApolloProvider>,
);
